import React from 'react';
import { VideoPreviewLeft, VideoPreviewRight } from './VideoPreviewArea';
import type { VideoOrientation } from './useVideoOrientation';

interface VideoShowProps {
    leftProps: any;
    rightProps: any;
    orientation: VideoOrientation;
}

export const VideoShow: React.FC<VideoShowProps> = ({ leftProps, rightProps, orientation }) => {
    return (
        <div className={`video-show video-show--${orientation}`}>
            <VideoPreviewLeft {...leftProps} orientation={orientation} />
            <VideoPreviewRight {...rightProps} />
        </div>
    );
};
